import React from 'react';

import {
  StorageOfUniqueServices,
  TestExecutionService,
} from '@qality/common-service';
import { TestExecutionPageContext } from '@qality/common-state';

import { QAlityFreeTextExecutionDetailsView } from './QAlityFreeTextExecutionDetails.view';

export const QAlityFreeTextExecutionDetails = ({ issueKey }: any) => {
  const [historyDetails, setHistoryDetails] = React.useState({});
  const { testExecution } = React.useContext(TestExecutionPageContext);

  React.useEffect(() => {
    const fetchHistoryDetails = async () => {
      const history = await TestExecutionService.getTestExecutionHistoryDetails(
        testExecution.id
      );
      const executionsHistoryUrl = StorageOfUniqueServices.get(
        'URLService'
      ).getTestCaseExecutionHistoryUrl(issueKey, issueKey);
      setHistoryDetails({
        executionsCount: history.numberOfExecutions,
        executionsHistoryUrl,
      });
    };
    fetchHistoryDetails();
  }, []);

  return (
    <QAlityFreeTextExecutionDetailsView
      executionsCount={historyDetails.executionsCount}
      executionsHistoryUrl={historyDetails.executionsHistoryUrl}
    />
  );
};
